export default "__VITE_ASSET__C0A9arvv__"